import { render, staticRenderFns } from "./ItineraryAdmin.vue?vue&type=template&id=82a0c19e&scoped=true"
import script from "./ItineraryAdmin.vue?vue&type=script&lang=js"
export * from "./ItineraryAdmin.vue?vue&type=script&lang=js"
import style0 from "./ItineraryAdmin.vue?vue&type=style&index=0&id=82a0c19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a0c19e",
  null
  
)

export default component.exports